export default {
  placeholder: 'Wähle einen Sensor',
};
